import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconSaveFalse$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSaveFalse extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '7367be33dfb8573cde4e9edd224a5afc3c0943b5', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'c4de94ab160c419d336298bc718efc64e57762b4', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '3e095d5497932b8e3797b80ec6935b596e959599', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m14 6 .4.32a.51.51 0 0 1 0 .68l-2.34 2.36 2.33 2.33a.5.5 0 0 1 0 .7l-.36.36a.5.5 0 0 1-.7 0L11 10.42l-2.32 2.33a.51.51 0 0 1-.71 0l-.35-.36a.48.48 0 0 1 0-.7L10 9.36l-2.35-2.3a.5.5 0 0 1 0-.71L8 6a.5.5 0 0 1 .68 0L11 8.3 13.3 6a.48.48 0 0 1 .7 0M3 18.5a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5H18a.5.5 0 0 0-.5.5v4h-13v-4A.5.5 0 0 0 4 13h-.5a.5.5 0 0 0-.5.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-save-false", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-save-false"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-save-false":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSaveFalse$1);
            }
            break;
    } });
}

const CosmosIconSaveFalse = CosmosIconSaveFalse$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSaveFalse, defineCustomElement };
